import React from 'react';
import { Link } from 'react-router-dom';
import './DestinationsPage.css';

const DestinationsPage = () => {
  // Sample destinations data - this can be replaced with your content
  const destinations = [
    {
      id: 'alleppey',
      name: 'Alleppey Backwaters',
      shortDesc: 'Experience the serene backwaters on a traditional houseboat.',
      image: 'https://images.unsplash.com/photo-1602216056096-3b40cc0c9944',
      tags: ['Backwaters', 'Houseboats', 'Nature']
    },
    {
      id: 'munnar',
      name: 'Munnar Tea Gardens',
      shortDesc: 'Explore the lush green tea plantations and misty mountains.',
      image: '/images/gallery/destinations/munnar2.jpg',
      tags: ['Hill Station', 'Tea Gardens', 'Wildlife']
    },
    {
      id: 'fort-kochi',
      name: 'Fort Kochi',
      shortDesc: 'Discover the colonial heritage and vibrant culture.',
      image: '/images/FortKochi.jpg',
      tags: ['Heritage', 'Culture', 'Beaches']
    },
    {
      id: 'wayanad',
      name: 'Wayanad',
      shortDesc: 'Encounter diverse wildlife in the Western Ghats.',
      image: '/images/Wayanad.jpg',
      tags: ['Wildlife', 'Adventure', 'Nature']
    },
    {
      id: 'kumarakom',
      name: 'Kumarakom',
      shortDesc: 'A cluster of islands on the Vembanad Lake with bird sanctuary.',
      image: '/images/Kumarakom.jpg',
      tags: ['Backwaters', 'Bird Sanctuary', 'Luxury']
    },
    {
      id: 'varkala',
      name: 'Varkala',
      shortDesc: 'A coastal town with stunning cliffs and pristine beaches.',
      image: '/images/Varkala.jpg',
      tags: ['Beaches', 'Cliffs', 'Spirituality']
    }
  ];

  return (
    <div className="destinations-page">
      <div className="destinations-hero">
        <div className="destinations-hero-overlay"></div>
        <div className="destinations-hero-content">
          <h1>Explore Kerala's Finest Destinations</h1>
          <p>Discover the diverse landscapes and rich cultural experiences</p>
        </div>
      </div>

      <section className="destinations-intro">
        <div className="container">
          <div className="section-header">
            <h2>Discover God's Own Country</h2>
            <p>From serene backwaters to misty hill stations, Kerala offers a diverse range of experiences</p>
          </div>
          
          <div className="intro-content">
            <p>
              Kerala, aptly nicknamed "God's Own Country," is a tropical paradise nestled in the southwestern tip of India. 
              This enchanting state is renowned for its breathtaking natural beauty, rich cultural heritage, and warm hospitality, 
              making it an ideal destination for tourists seeking an unforgettable experience.
            </p>
            
            <div className="kerala-overview">
              <div className="overview-section">
                <h3>Natural Wonders</h3>
                <ul>
                  <li><strong>Backwaters:</strong> Kerala's tranquil backwaters, a network of serene lakes, rivers, and canals, offer a relaxing cruise experience amidst lush green landscapes.</li>
                  <li><strong>Beaches:</strong> The state boasts some of the most stunning beaches in the country, including Kovalam, Varkala, and Marari, perfect for swimming, sunbathing, and water sports.</li>
                  <li><strong>Hill Stations:</strong> The Western Ghats mountain range offers picturesque hill stations like Munnar, Wayanad, and Thekkady, providing a cool retreat from the tropical heat.</li>
                  <li><strong>Wildlife:</strong> Kerala is home to several national parks and wildlife sanctuaries, such as Periyar and Eravikulam, showcasing the state's rich biodiversity.</li>
                </ul>
              </div>
              
              <div className="overview-section">
                <h3>Cultural Heritage</h3>
                <ul>
                  <li><strong>Temples:</strong> Kerala is famous for its ancient temples, like the Padmanabhaswamy Temple in Thiruvananthapuram and the Guruvayur Temple, showcasing the state's rich spiritual heritage.</li>
                  <li><strong>Festivals:</strong> The state celebrates numerous vibrant festivals, including Onam, Vishu, and Thrissur Pooram, offering a glimpse into Kerala's rich cultural traditions.</li>
                  <li><strong>Art Forms:</strong> Kerala is renowned for its classical art forms, such as Kathakali, Mohiniyattam, and Thullal, which are an integral part of the state's cultural identity.</li>
                </ul>
              </div>
              
              <div className="overview-section">
                <h3>Cuisine</h3>
                <ul>
                  <li><strong>Spicy Delights:</strong> Kerala's cuisine is famous for its spicy flavors, with popular dishes like idli, dosa, sambhar, and rasam.</li>
                  <li><strong>Seafood:</strong> The state's coastal location offers an abundance of fresh seafood, with popular dishes like karimeen and chemmeen.</li>
                  <li><strong>Traditional Sweets:</strong> Kerala is famous for its traditional sweets, like ada pradhaman and payasam.</li>
                </ul>
              </div>
              
              <div className="overview-section">
                <h3>Tourism Initiatives</h3>
                <ul>
                  <li><strong>Responsible Tourism:</strong> Kerala has implemented responsible tourism initiatives, focusing on sustainable tourism practices and community involvement.</li>
                  <li><strong>Homestays:</strong> The state offers a range of homestays, allowing tourists to experience traditional Kerala hospitality and culture.</li>
                  <li><strong>Tourism Infrastructure:</strong> Kerala has invested heavily in developing its tourism infrastructure, including airports, roads, and hotels.</li>
                </ul>
              </div>
              
              <div className="overview-section">
                <h3>Best Time to Visit</h3>
                <p>Kerala is a year-round destination, but the best time to visit is from September to March, when the weather is cool and pleasant.</p>
              </div>
              
              <div className="overview-section">
                <h3>Getting There</h3>
                <p>Kerala has three international airports: Cochin International Airport (COK), Thiruvananthapuram International Airport (TRV), and Calicut International Airport (CCJ). The state is also well-connected by rail and road.</p>
              </div>
            </div>
            
            <p>
              Our carefully curated selection of destinations showcases the best that Kerala has to offer. 
              Whether you seek adventure, relaxation, cultural immersion, or wellness experiences, 
              you'll find the perfect destination for your dream Kerala holiday.
            </p>
          </div>
        </div>
      </section>

      <section className="destinations-grid-section">
        <div className="container">
          <div className="destinations-filter">
            <h3>Find Your Perfect Destination</h3>
            <div className="filter-tags">
              <button className="filter-tag active">All</button>
              <button className="filter-tag">Backwaters</button>
              <button className="filter-tag">Beaches</button>
              <button className="filter-tag">Hill Stations</button>
              <button className="filter-tag">Wildlife</button>
              <button className="filter-tag">Heritage</button>
            </div>
          </div>
          
          <div className="destinations-grid">
            {destinations.map(destination => (
              <div className="destination-card" key={destination.id}>
                <div className="destination-image">
                  <img src={destination.image} alt={destination.name} />
                  <div className="destination-tags">
                    {destination.tags.map(tag => (
                      <span key={tag} className="destination-tag">{tag}</span>
                    ))}
                  </div>
                </div>
                <div className="destination-info">
                  <h3>{destination.name}</h3>
                  <p>{destination.shortDesc}</p>
                  <Link to={`/destinations/${destination.id}`} className="btn btn-outline">
                    Explore More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="travel-tips">
        <div className="container">
          <div className="section-header">
            <h2>Travel Tips for Kerala</h2>
            <p>Make the most of your journey with these helpful insights</p>
          </div>
          <div className="tips-grid">
            <div className="tip-card">
              <h3>Best Time to Visit</h3>
              <p>October to February offers pleasant weather for exploring Kerala. The monsoon season (June to September) is ideal for Ayurvedic treatments and lush landscapes.</p>
            </div>
            <div className="tip-card">
              <h3>Local Cuisine</h3>
              <p>Don't miss Kerala's seafood, appam with stew, sadhya (traditional feast), and karimeen pollichathu (pearl spot fish).</p>
            </div>
            <div className="tip-card">
              <h3>Cultural Etiquette</h3>
              <p>Dress modestly when visiting temples and remove shoes before entering. Greet people with a smile and "Namaste" or "Namaskaram".</p>
            </div>
            <div className="tip-card">
              <h3>Transportation</h3>
              <p>Kerala has a good network of buses and trains. For flexibility, consider hiring a private car with a driver for your journey.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="destination-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Explore Kerala?</h2>
            <p>Let us help you plan the perfect itinerary for your Kerala adventure</p>
            <Link to="/contact" className="btn btn-primary">Plan Your Trip</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DestinationsPage; 